import { Box, Card, Skeleton } from '@mui/material';

export const GamesViewSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {[1, 2].map((group) => (
        <Box key={group}>
          {/* Date Header Skeleton */}
          <Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />

          {/* Games List Skeleton */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[1, 2, 3].map((item) => (
              <Card
                key={item}
                sx={{
                  borderRadius: 2,
                  p: 2,
                  bgcolor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  boxShadow: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                {/* Header Row: Time/Vol and View Button */}
                <Box
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <Box sx={{ display: 'flex', gap: 1.5 }}>
                    <Skeleton variant="text" width={50} height={16} />
                    <Skeleton variant="text" width={70} height={16} />
                  </Box>
                  <Skeleton variant="rounded" width={110} height={24} sx={{ borderRadius: 12 }} />
                </Box>

                {/* Main Content Area: Team Info & Betting Grid */}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: { xs: 2.5, md: 2 },
                    alignItems: { xs: 'stretch', md: 'center' },
                    justifyContent: 'space-between',
                  }}
                >
                  {/* Team Info Column */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1 }}>
                    {[1, 2].map((team) => (
                      <Box
                        key={team}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                          <Skeleton
                            variant="rounded"
                            width={20}
                            height={20}
                            sx={{ borderRadius: 1 }}
                          />
                          <Skeleton variant="circular" width={24} height={24} />
                          <Skeleton variant="text" width={80} height={20} />
                        </Box>
                        <Skeleton variant="text" width={30} height={20} />
                      </Box>
                    ))}
                  </Box>

                  {/* Betting Grid */}
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: { md: 320 } }}
                  >
                    {/* Web View (2 rows, 3 columns) */}
                    <Box
                      sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', gap: 1 }}
                    >
                      {[1, 2].map((row) => (
                        <Box key={row} sx={{ display: 'flex', gap: 1 }}>
                          <Skeleton
                            variant="rounded"
                            sx={{ flex: 1, height: 36, borderRadius: 1 }}
                          />
                          <Skeleton
                            variant="rounded"
                            sx={{ flex: 1, height: 36, borderRadius: 1 }}
                          />
                          <Skeleton
                            variant="rounded"
                            sx={{ flex: 1, height: 36, borderRadius: 1 }}
                          />
                        </Box>
                      ))}
                    </Box>

                    {/* Mobile View (1 row, 2 columns wide buttons) */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1, width: '100%' }}>
                      <Skeleton variant="rounded" sx={{ flex: 1, height: 48, borderRadius: 2 }} />
                      <Skeleton variant="rounded" sx={{ flex: 1, height: 48, borderRadius: 2 }} />
                    </Box>
                  </Box>
                </Box>
              </Card>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
